// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, CheckAutocompleteModel } from "@insite/client-framework/Store/CommonHandlers/StartSearch";


export const XngCheckAutocompleteModel: typeof CheckAutocompleteModel = props => {
    // <XNG-Change>
    if (props.parameter.autocompleteModel?.properties["isSearchTermRedirect"] === "true") {
        props.redirectUrl = `/${props.parameter.searchPath}?query=${props.parameter.query}`;
    }
    // </XNG-Change>

    if (props.parameter.autocompleteModel?.products?.length === 1) {
        props.redirectUrl = props.parameter.autocompleteModel.products[0].url;
    }
};

replaceInChain(chain, CheckAutocompleteModel, XngCheckAutocompleteModel);
